import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import ReactionCreateEditForm from './Components/ReactionCreateEditForm';
import ReactionApi from './ReactionApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: ReactionCreateEditForm,
                getCreate: ReactionApi.create,
                defaults: {},
                successMessage: "Reaction Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}